<template>
  <div>
    <ViewInactiveAlert v-if="showInactiveAlert" @onClickResume="onClickResume" @onClickContinue="onClickContinue"/>
  </div>
</template>

<script>
import ViewInactiveAlert from '@/components/modals/ViewInactiveAlert'
export default {
  props: {
    clickedResumeButton: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ViewInactiveAlert,
  },
  computed: {
    selectedSiteId: function () {
      return this.$store.getters.selectedSiteId
    },
    site: function () {
      return this.$store.getters.site(this.selectedSiteId)
    },
  },
  data() {
    return {
      showInactiveAlert: false,
      inactiveTimer: 1000 * 60 * 5, // 5분
    };
  },
  created() {
    this.startCheckUserMouseMoving()
  },
  mounted() {
  },
  beforeDestroy() {
    this.stopCheckUserMouseMoving()
  },
  methods: {
    startCheckUserMouseMoving: function () {
      document.addEventListener('mousemove', this.listenMouseMove)
      this.listenMouseMove()
    },
    stopCheckUserMouseMoving: function () {
      document.removeEventListener('mousemove', this.listenMouseMove)
    },
    listenMouseMove: function () {
      if (this.mouseMove$t) {
        clearTimeout(this.mouseMove$t);
        this.mouseMove$t = null;
      }

      this.mouseMove$t = setTimeout(async() => {
        // hasVideoTimeoutInWeb 0이면 기능 비활성화
        if (this.site?.statusInfo?.hasVideoTimeoutInWeb === 0) return

        this.showInactiveAlert = true;
      }, this.inactiveTimer);
    },
    onClickResume: async function () {
      this.showInactiveAlert = false;
      await this.$webrtc.requestAllPeers()
    },
    onClickContinue: async function () {
      this.showInactiveAlert = false;
      if (this.mouseMove$t) {
        clearTimeout(this.mouseMove$t);
        this.mouseMove$t = null;
      }
    },
  }
}
</script>

<style>

</style>